import { render } from "./ProductMiniCart.vue?vue&type=template&id=c5b32c50"
import script from "./ProductMiniCart.vue?vue&type=script&lang=js"
export * from "./ProductMiniCart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__